<div class="application-container" [class.unauth-page]="isNotLoggedIn()">
  <router-outlet></router-outlet>
</div>
<!-- !tw-text-[#04034f] -->
@if (isNotLoggedIn()) {
  <footer
    class="tw-w-screen tw-flex tw-flex-row tw-flex-wrap tw-px-3 tw-py-9 tw-mt-auto md:tw-flex-col !tw-bg-white"
    >
    <div id="Contact" class="container new-font-dark">
      <div class="contacts-container">
        <div class="h1 !tw-text-[#04034f] tw-my-8 tw-hidden lg:tw-block">Contact Us</div>
        <div class="tw-my-8">
          <div>
            <span class="fw-bold">Phone: </span>
            <a href="tel:+18003350911" class="soft-blue-font tw-no-underline">
              <span class="soft-blue-font tw-cursor-pointer">+1 800-335-0911 x7 </span>
            </a> (available globally)</div><div>
            <span class="fw-bold">Email: </span>
            <a href="mailto:oordinators.na@ai-media.tv" class="soft-blue-font tw-no-underline">
              <span class="soft-blue-font tw-cursor-pointer">coordinators.na&#64;ai-media.tv</span>
            </a></div>
          </div>
          <!--                <div class="tw-my-8">-->
          <!--                    <a-->
          <!--                        target="_blank"-->
          <!--                        [href]="ai_media_contact_url"-->
          <!--                        class="btn btn-primary btn-lg ms-auto new-btn-color tw-rounded-lg"-->
          <!--                        type="button"-->
          <!--                    >-->
          <!--                        Email Us <i class="bi bi-arrow-right tw-ml-4 hover:tw-text-white"></i>-->
        <!--                    </a>-->
      <!--                </div>-->
    </div>
  </div>
  <div
    class="tw-flex tw-flex-col tw-mx-auto md:tw-flex-row tw-pb-1"
    [class.footer-links]="isNotLoggedIn()"
    >
    <a
      class="text-primary tw-text-center md:tw-mx-3"
      [class.unauth-style]="isNotLoggedIn()"
      href="https://www.ai-media.tv/terms-of-service/"
      target="_blank"
      rel="noopener noreferrer"
      >
      AI-Media Terms of Service
    </a>
    <a
      class="text-primary tw-text-center md:tw-mx-3"
      [class.unauth-style]="isNotLoggedIn()"
      href="https://www.ai-media.tv/privacy-policy/"
      target="_blank"
      rel="noopener noreferrer"
      >
      Privacy Policy
    </a>
    <a
      class="text-primary tw-text-center md:tw-mx-3"
      [class.unauth-style]="isNotLoggedIn()"
      href="https://www.ai-media.tv/cookie-notice/"
      target="_blank"
      rel="noopener noreferrer"
      >
      Cookie Notice
    </a>
    <a
      class="text-primary tw-text-center md:tw-mx-3 tw-mb-2 md:tw-mb-0"
      [class.unauth-style]="isNotLoggedIn()"
      [class.tw-text-sm]="isNotLoggedIn()"
      [class.tw-no-underline]="isNotLoggedIn()"
      [class.!tw-font-sans]="isNotLoggedIn()"
      [href]="getCheckPointUrl()"
      target="_blank"
      rel="noopener noreferrer"
      routerLinkActive="active"
      >
      Knowledge Base
    </a>
  </div>
  <div
    aria-hidden="true"
    class="tw-flex tw-flex-col tw-mx-auto md:tw-flex-row"
    [class.unauth-style]="isNotLoggedIn()"
    [class.!tw-text-lg]="isNotLoggedIn()"
    >
    <span class="tw-text-center md:tw-mr-1">
      &copy; {{now | date:'YYYY'}} AI-Media |
    </span>
    <span class="tw-text-center md:tw-ml-1">
      All Rights Reserved
    </span>
  </div>
</footer>
}
<!-- OLD STYLING -->
@if (!isNotLoggedIn()) {
  <footer
    class="tw-w-screen tw-flex tw-flex-row tw-flex-wrap tw-px-3 tw-py-9 tw-mt-auto md:tw-flex-col"
    >
    <div class="tw-flex tw-flex-col tw-basis-full md:tw-basis-auto tw-mx-auto md:tw-flex-row tw-pb-1">
      <a
        class="text-primary tw-text-center md:tw-mx-3"
        href="https://www.ai-media.tv/terms-of-service/"
        target="_blank"
        rel="noopener noreferrer"
        routerLinkActive="active"
        >
        AI-Media Terms of Service
      </a>
      <a
        class="text-primary tw-text-center md:tw-mx-3"
        href="https://www.ai-media.tv/privacy-policy/"
        target="_blank"
        rel="noopener noreferrer"
        routerLinkActive="active"
        >
        Privacy Policy
      </a>
      @if (this_user) {
        <a
          class="text-primary tw-text-center md:tw-mx-3 tw-mb-2 md:tw-mb-0"
          [href]="getCheckPointUrl()"
          target="_blank"
          rel="noopener noreferrer"
          routerLinkActive="active"
          >
          Knowledge Base
        </a>
      }
    </div>
    <div
      aria-hidden="true"
      class="tw-flex tw-flex-col tw-basis-full md:tw-basis-auto tw-mx-auto md:tw-flex-row"
      >
      <span class="tw-text-center md:tw-mr-1">
        &copy; {{now | date:'YYYY'}} AI-Media | Access Innovation Media.
      </span>
      <span class="tw-text-center md:tw-ml-1">
        All Rights Reserved
      </span>
    </div>
  </footer>
}
